import { useSyncExternalStore } from "react";
import { createExternalStore } from "../external-store.js";

// The palette taxonomy rider (TASK.md, seam gate): a failure from a palette-context call
// renders inline, in the palette, register-correct — never a toast. The failure handler sets
// this message; the command palette subscribes and clears it on its own (closing, or the next
// keystroke starting a new search).
const paletteFailureStore = createExternalStore<string | null>(null);

export const setPaletteFailure = paletteFailureStore.set;

export function clearPaletteFailure(): void {
  paletteFailureStore.set(null);
}

export function usePaletteFailure(): string | null {
  return useSyncExternalStore(paletteFailureStore.subscribe, paletteFailureStore.get);
}
